//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vue-awesome/icons/angle-right'
import Icon from 'vue-awesome/components/Icon'
import {mapActions} from 'vuex';

export default {
  name: "mine",
  components: {
    'v-icon': Icon
  },
  data(){
    return {
      userinfo:{}
    }
  },
  methods:{
    ...mapActions(['changeUserInfo','logout']),
  },
  created() {
    this.axios.post('/xcx/User/index').then(res=>{
      this.changeUserInfo(res.data.data);
      this.userinfo=res.data.data;
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/mine/mine.vue